module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.isCaminhoParana) ? _c('h3', {
    staticClass: "title"
  }, [_vm._v("Adesão Caminhos do Paraná")]) : (_vm.planId == 62 || _vm.planId == 64) ? _c('h3', {
    staticClass: "title"
  }, [_vm._v("\n        Adesão Rodosol\n      ")]) : _c('h3', {
    staticClass: "title"
  }, [_vm._v("Adesão Move Mais")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])]), _vm._v(" "), (_vm.code == undefined) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "wizard margin-b20 ad",
    class: _vm.step == 1 ?
      ' past1 ' :
      _vm.step == 2 ?
      ' past2 ' :
      _vm.step > 2 ?
      ' past4 ' :
      ''
  }, [_c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 0, past: _vm.step > 0
    }
  }, [_vm._m(0), _vm._v(" "), _c('small', [_vm._v("Plano e condições")]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [(_vm.planId == 33) ? _c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("\n                Plano e condições\n              ")]) : _c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Plano e carga inicial")])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 1, past: _vm.step > 1
    }
  }, [_c('div', {
    staticClass: "icon-step"
  }, [(_vm.isPJ) ? _c('i', {
    staticClass: "icon-globe"
  }) : _c('i', {
    staticClass: "icon-avatar"
  })]), _vm._v(" "), _c('small', [_vm._v("Seus dados")]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [(_vm.isPJ) ? _c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Dados da Empresa")]) : _c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Seus dados")])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 2, past: _vm.step > 2
    }
  }, [_vm._m(1), _vm._v(" "), _c('small', [_vm._v("Cadastro de veículos")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    class: {
      active: _vm.step == 3, past: _vm.step > 3
    }
  }, [_vm._m(3), _vm._v(" "), _c('small', [_vm._v("Resumo e confirmação")]), _vm._v(" "), _vm._m(4)])])])]), _vm._v(" "), (_vm.isCaminhoParana) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-danger margin-b10",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v("\n      " + _vm._s(_vm.msgError) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.subtitle[_vm.step]) + "\n    ")]), _vm._v(" "), (_vm.step == 2 && _vm.planId == 6) ? _c('div', {
    staticClass: "alert alert-warning margin-b10",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v(" Essa etapa não se aplica a este plano.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.step == 0) ? [(_vm.checkPlan) ? _c('choose-recharge', {
    ref: "chooseRecharge",
    attrs: {
      "contract": _vm.request.contract,
      "minValue": _vm.minValue
    },
    on: {
      "valorSelecionado": _vm.handleValorSelecionado
    }
  }) : _c('choose-plan', {
    ref: "choosePlan",
    attrs: {
      "contract": _vm.request.contract
    }
  })] : _vm._e(), _vm._v(" "), (_vm.step == 1 && !_vm.isPJ) ? _c('user-data', {
    ref: "userData",
    attrs: {
      "user": _vm.request.account,
      "address": _vm.address,
      "blockTaxIdNumber": _vm.isCaminhoParana
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 1 && _vm.isPJ) ? _c('company-data', {
    ref: "userData",
    attrs: {
      "account": _vm.request.account,
      "address": _vm.address,
      "blockTaxIdNumber": _vm.isCaminhoParana
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('vehicles', {
    staticClass: "margin-b20",
    attrs: {
      "vehicles": _vm.vehicles,
      "planId": _vm.planId,
      "type": "",
      "allowVehicles": _vm.qtdAllowed
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('generic-summary', {
    ref: "GenericSummary",
    attrs: {
      "contract": _vm.request.contract,
      "account": _vm.request.account,
      "order": this.salesOrder,
      "showAddress": true,
      "addressInit": _vm.address,
      "skipBillingSection": true,
      "promotionCode": this.promotionCode
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('div', [_c('div', {
    staticClass: "action-buttons-box"
  }, [_c('div', {
    staticClass: "adhesion-footer-nav",
    class: {
      'adhesion-footer-nav--final-mobile': _vm.isMobile && _vm.step === 3
    }
  }, [_c('div', {
    attrs: {
      "id": "btn-container-adhesion-back-cancel"
    }
  }, [(_vm.step != 0 && !(_vm.isMobile && _vm.step === 3)) ? _c('button', {
    attrs: {
      "id": "button-back-adhesion"
    },
    on: {
      "click": function($event) {
        return _vm.backStep()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1449_206)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 5.33398L5.3335 8.00065M5.3335 8.00065L8.00016 10.6673M5.3335 8.00065H10.6668M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#5D3B81",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1449_206"
    }
  }, [_c('rect', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]), _vm._v("\n\n              Voltar\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "id": "button-cancel-adhesion"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 4L4 12M4 4L12 12",
      "stroke": "#E21C12",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn-container-adhesion-advance"
    }
  }, [(
    _vm.step < 3 &&
    !(_vm.isCaminhoParana && _vm.step == 0) &&
    _vm.isMobile &&
    _vm.planId != 31 &&
    _vm.planId != 32
  ) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (
    _vm.step < 3 &&
    !(_vm.isCaminhoParana && _vm.step == 0) &&
    _vm.isMobile &&
    _vm.isRechargeSelected &&
    (_vm.planId == 31 || _vm.planId == 32)
  ) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (
    _vm.step < 3 &&
    !(_vm.isCaminhoParana && _vm.step == 0) &&
    !_vm.isMobile &&
    _vm.planId != 31 &&
    _vm.planId != 32
  ) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (
    _vm.step < 3 &&
    !(_vm.isCaminhoParana && _vm.step == 0) &&
    !_vm.isMobile &&
    _vm.isRechargeSelected &&
    (_vm.planId == 31 || _vm.planId == 32)
  ) ? _c('button', {
    attrs: {
      "id": "button-next-adhesion"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n              Avançar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 3 && !_vm.isMobile) ? _c('button', {
    attrs: {
      "id": "button-concluir-adhesion"
    },
    on: {
      "click": function($event) {
        return _vm.startRequest()
      }
    }
  }, [_vm._v("\n              Finalizar pedido\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step == 3 && _vm.isMobile) ? _c('button', {
    attrs: {
      "id": "button-concluir-adhesion-mobile"
    },
    on: {
      "click": function($event) {
        return _vm.startRequest()
      }
    }
  }, [_vm._v("\n              Finalizar pedido\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e()])])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('success-page', {
    attrs: {
      "code": _vm.code,
      "type": 'adhesion',
      "salesOrder": _vm.salesResponse
    }
  }), _vm._v(" "), _c('error-page', {
    attrs: {
      "validacaoFraude": _vm.validacaoFraude,
      "code": _vm.code,
      "type": 'adhesion',
      "taxIdNumber": _vm.request.account.taxIdNumber,
      "password": _vm.request.account.accountAuthentication.password,
      "salesOrder": _vm.salesResponse
    }
  }), _vm._v(" "), (_vm.step == 0 && !_vm.isPJ) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), _c('adhesion-confirm-2fa', {
    ref: "confirm2fa",
    attrs: {
      "user": _vm.request.account
    },
    on: {
      "nextStep": _vm.nextStep
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-plans"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-vehicle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Cadastro de veículos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-confirmation-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline"
  }, [_c('h5', {
    staticClass: "txt-step no-margin"
  }, [_vm._v("Resumo e confirmação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-info margin-b10"
  }, [_c('span', [_vm._v("\n            Você tem isenção na passagem nas praças de pedágio pelo Caminhos\n            do Paraná. Nada será cobrado pela passagem. Porém para adquirir\n            seu TAG é necessário, no ato da adesão, escolher um tipo de plano.\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "bold"
  }, [_vm._v("Dúvidas?")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('p', {
    staticClass: "margin-b30"
  }, [_vm._v("\n        Ficou com alguma dúvida sobre a adesão? Sem problemas, é só consultar\n        nosso\n        "), _c('b', [_vm._v("FAQ de Planos")]), _vm._v(" logo abaixo ou falar com a nossa\n        "), _c('b', [_vm._v("Central de Relaconamento")]), _vm._v(" nos telefones\n        "), _c('b', [_vm._v("4000 2901")]), _vm._v(" (capitais e regiões metropolitanas) ou\n        "), _c('b', [_vm._v("0800 777 1022")]), _vm._v(" (demais localidades).\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n          Existe cobrança de mensalidade?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n            Não, nos nossos planos para você não há cobrança de mensalidade.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n          Preciso fazer uma carga quando compro?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n            Nos planos pré-pagos é necessário fazer uma carga inicial para\n            poder começar a utilizar nossos serviços, o valor pode ser: R$\n            50,00 - R$ 100,00 - R$ 150,00 R$ 200,00 - R$ 250,00 - R$ 300,00 -\n            R$ 350,00 - R$ 400,00 - R$ 450,00 ou R$ 500,00. Quanto maior o\n            valor escolhido menor é a porcentagem da nossa taxa de serviço.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n          Há validade dos créditos?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n            Não, seus créditos nunca expiram, aproveite!\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n          Como funciona o TAG?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n            Após ativar e colar, o TAG permite que você passe em pedágios sem\n            fila! As cancelas automáticas identificam seu veículo através do\n            adesivo, liberam a passagem e cobram o valor do saldo em sua\n            conta.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n          Como retiro ou recebo meu(s) TAG(s)?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n            Você não precisa retirar, nós enviamos para você! Os TAGs serão\n            enviados para o endereço que você informar no cadastro, você pode\n            ainda acompanhar o status da entrega no menu pedidos da área do\n            cliente.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n          Tem limite de veículos?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n            Não, você pode habilitar quantos veículos quiser.\n          ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-58823a00!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/adhesion.vue
// module id = 2135
// module chunks = 1